import { sites, featuredSiteIds } from '@/mocks/navigation';

export default function FeaturedSites() {
  const featuredSites = featuredSiteIds
    .map((id) => {
      for (const catSlug of Object.keys(sites)) {
        const found = sites[catSlug].find((s) => s.id === id);
        if (found) return found;
      }
      return null;
    })
    .filter(Boolean) as Array<{
      id: string;
      name: string;
      url: string;
      description: string;
      icon: string;
      tags: string[];
    }>;

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="w-full">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑精心挑选的优质网站</p>
          </div>
          <div className="hidden sm:flex items-center gap-1">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredSites.map((site, index) => {
            const isAccent = index % 3 === 1;
            return (
              <a
                key={site.id}
                href={site.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer hover:scale-[1.01]"
              >
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-110 ${
                    isAccent
                      ? 'bg-accent-100 text-accent-600'
                      : 'bg-primary-100 text-primary-600'
                  }`}
                >
                  <i className={`${site.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-base font-semibold text-foreground-900">{site.name}</h3>
                    <i className="ri-arrow-right-up-line text-foreground-400 text-sm opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2">
                    {site.description}
                  </p>
                  <div className="flex flex-wrap gap-1.5">
                    {site.tags.slice(0, 3).map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}